"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M15 8.417V18a1 1 0 0 1-1.999 0V8.417l-1.129 1.13a1 1 0 0 1-1.413-1.413l2.842-2.846A.984.984 0 0 1 13.999 5a.985.985 0 0 1 .701.285l2.839 2.847a1.001 1.001 0 0 1-1.413 1.413L15 8.417ZM6 21.5h16.001v-7a1.001 1.001 0 0 1 1.999 0v8a.987.987 0 0 1-.292.701 1 1 0 0 1-.709.3h-18a1.001 1.001 0 0 1-1-1v-8a1.001 1.001 0 0 1 1.998 0L6 21.5Z",
    clipRule: "evenodd"
  })]
});